import React, { Component } from "react";
import axios from "axios";
import $ from "jquery";
import HeadersAuth from "../Layouts/HeadersAuth";
export class ForgotPasswordEmail extends Component {
  constructor(props) {
    super(props);

   

    const url = "";

    this.state = { email: "", loading: false };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    // //this.PrintWindow = this.PrintWindow.bind(this);
  }

  handleChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }

  handleSubmit = (event) => {
    const headers = {
      "Content-Type": "application/json",
    };
    event.preventDefault();
    this.setState({ loading: true });
    console.log(this.state);
    axios
      .post(this.api_url+"staff/forgotpassword", this.state, {
        headers: headers,
      })
      .then((response) => {
        this.setState({ loading: false });
        console.log(response.data);
        if (response.data["success"]) {
          localStorage.setItem("changePassword", response.data["success"]);
          $(".alert-error").hide();
          $(".alert-success").show();
        } else {
          $(".alert-success").hide();
          $(".alert-error").show();
        }
      })
      .catch((error) => {
        $(".alert-error").show();
        this.setState({ loading: false });
        console.log(error);
      });
    console.log(this.state);
  };

  componentDidMount() {
    //     const article = { title: 'React POST Request Example' };
    // axios.post('https://reqres.in/api/articles', article)
    // .then(response => this.setState({ articleId: response.data.id }));
    //remove loader
    document.getElementById("LoadingModal").style.display = "none";
  }

  render() {
    const font16 = { fontSize: "16px" };
    const fontFamilyNunito = { fontFamily: "Nunito, sans-serif" };
    const floatRight = { float: "right;" };
    const floatLeft = { float: "left;" };
    const displayHidden = { display: "none" };
    const { email } = this.state;
    const loading = this.state.loading;

    return (
      <div>
        <HeadersAuth />
        <main>
          <div className="container p-2">
            <form onSubmit={this.handleSubmit}>
              <div className="form-row pt-5 text-lg-center  p-1">
                <h4 className="text-capitalize">Forgot Password</h4>
              </div>
              <div className="form-row ">
                <div className="col-md-4 p-2">
                  <div className="py-1">
                    <h6 className="text-capitalize" style={fontFamilyNunito}>
                      Email
                    </h6>
                    <input
                      className="form-control"
                      onChange={this.handleChange}
                      value={email}
                      name="email"
                      type="email"
                      required
                    />
                  </div>
                </div>
              </div>
              <div
                id="loginSuccess"
                className="alert alert-success"
                style={displayHidden}
                role="alert"
              >
                <strong>Success! </strong>Click the Link below to reset your
                password.<a href="/update/password/">here</a>
              </div>
              <div
                id="loginSuccess"
                className="alert alert-danger"
                style={displayHidden}
                role="alert"
              >
                <strong>Error! </strong>User does not exist in our database
              </div>
              <button
                className="btn btn-primary btn-warning rounded-pill px-5 font-weight-bold"
                type="submit"
                style={floatLeft}
              >
                {" "}
                {loading ? <span>Loading...</span> : <span>Submit</span>}
              </button>

              <div style={displayHidden} className="col col-6">
                <button
                  className="btn btn-primary btn-warning rounded-pill px-4 font-weight-bold"
                  type="button"
                  style={floatRight}
                >
                  Send To Triage
                </button>
              </div>
              <div className="col col-6"></div>
            </form>
          </div>
        </main>
      </div>
    );
  }
}

export default ForgotPasswordEmail;
